import { Component, OnInit } from '@angular/core';
import { PageSize } from '../../core/dto/page.size';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { Pagination } from '../../core/dto/pagination';
import { SystemLogService } from '../../core/services/system-log.service';
import { UserService } from '../../core/services/user.service';
import { RolesService } from '../../core/services/roles.service';
import { SETTINGS } from '../../core/config/common.settings';

@Component({
  selector: 'app-system-log',
  templateUrl: './system-log.component.html',
  styleUrls: ['./system-log.component.scss'],
})
export class SystemLogComponent implements OnInit {
  breadcrumbs = [
    {
      title: 'System Log',
      icon: 'user',
    },
  ];
  loading = false;
  skeletonTableColumns: any[] = [
    'Date & Time',
    'User Name',
    'User Role',
    'Module',
    'Action',
    'Details',
  ];
  data: any[] = [];
  pageSize = new PageSize();
  sortField: any;
  sortOrder: any = -1;

  filterUser: any;
  userOptions: any[] = [];
  filterRole: any;
  rolesOptions: any[] = [];
  filterModule: any;
  moduleOptions = SETTINGS.MODULE_CATEGORY;
  department: any = '';

  constructor(
    private systemLogService: SystemLogService,
    private userService: UserService,
    private rolesService: RolesService,
  ) {}
  ngOnInit() {
    this.userService.loggedInUserSelectedDepartment.subscribe((res) => {
      this.department = res as string;
      this.resetSearch();
    });
    this.getRoleOptions();
    this.getUserOptions();
  }
  getRoleOptions(): void {
    this.rolesService.getRolesForOptions().then((res) => {
      this.rolesOptions = res as any[];
    });
  }
  getUserOptions(): void {
    this.userService.getUsersForOptions().then((res) => {
      this.userOptions = res as any[];
    });
  }

  onTableParamsChange(params: NzTableQueryParams): void {
    this.pageSize.pageSize = params.pageSize;
    this.pageSize.pageIndex = params.pageIndex;
    this.getPagedLogReport();
  }
  search(): void {
    this.sortField = null;
    this.sortOrder = -1;
    this.pageSize = new PageSize();
    this.getPagedLogReport();
  }
  resetSearch() {
    this.filterUser = null;
    this.filterRole = null;
    this.filterModule = null;
    this.sortField = null;
    this.sortOrder = -1;
    this.pageSize = new PageSize();
    this.getPagedLogReport();
  }
  getPagedLogReport() {
    this.loading = true;
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      filters: {
        department: this.department,
        role: this.filterRole,
        user: this.filterUser,
        module: this.filterModule,
      },
    });
    this.systemLogService.getPagedLogReport(payload).then((res: any) => {
      this.loading = false;
      this.data = res[0]?.data;
      this.pageSize.length = res[0]?.metadata[0]?.total;
    });
  }
}
